export default {
  meta: {
    title: '素材管理', // 招商管理-素材管理
    url: '/investment' // 埋点用，记录所属模块
  },
};
